import { contentTypes } from '../types';

export const STATUS_OPTIONS: { value: contentTypes.Status; label: string }[] = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Deactivated' },
  { value: 'archived', label: 'Archived' },
];

export const STATUS_LABELS: Record<contentTypes.Status, string> = {
  active: 'Active',
  inactive: 'Deactivated',
  archived: 'Archived',
};

/** Allowed next statuses from the current one (includes no-op). */
export const ALLOWED_STATUS_TRANSITIONS: Record<contentTypes.Status, contentTypes.Status[]> = {
  active: ['active', 'inactive', 'archived'],
  inactive: ['inactive', 'active', 'archived'],
  // Archive → Deactivated is forbidden; restore to Active first.
  archived: ['archived', 'active'],
};

export const isStatusTransitionAllowed = (
  from: contentTypes.Status,
  to: contentTypes.Status
): boolean => ALLOWED_STATUS_TRANSITIONS[from].includes(to);

export const getEditableStatusOptions = (
  currentStatus: contentTypes.Status
): { value: contentTypes.Status; label: string; disabled?: boolean }[] =>
  STATUS_OPTIONS.map((option) => ({
    ...option,
    disabled: !isStatusTransitionAllowed(currentStatus, option.value),
  }));

export const getStatusBadgeColor = (status: contentTypes.Status): string => {
  switch (status) {
    case 'active':
      return 'teal';
    case 'inactive':
      return 'red';
    case 'archived':
      return 'gray';
    default:
      return 'gray';
  }
};
